import css from "./Image.module.css";

export function Image(props: {
  alt?: string;
  src: string;
  width?: number;
  height?: number;
  border?: number;
  float?: "left" | "right" | "center";
}) {
  const { src, alt, float, height, width, border } = props;
  if (float === "center") {
    return (
      <div className={css.root}>
        <div className={css.centerWrap}>
          <img
            src={src}
            alt={alt}
            style={{
              width,
              height,
              ...(border && { borderColor: "#3e3c3a", borderWidth: border }),
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={css.root}>
      <img
        src={src}
        alt={alt}
        style={{
          width,
          height,
          float,
          ...(border && { borderColor: "#3e3c3a", borderWidth: border }),
        }}
      />
    </div>
  );
}
